module.exports = __webpack_public_path__ + "img/unicuritiba.7d737805.svg";